import React from "react";

import { EmployeeSummary } from "@performyard/service-contracts";

import { BulletListSection } from "../components/BulletListSection";
import { StatCard, StatRow, StatRows } from "../components/StatCard";

const fmtDays = (d: number | null) => {
	if (d === null) return "—";
	const rounded = Math.round(d);
	if (rounded === 0) return d > 0 ? "<1 day" : "0 days";
	return `${rounded} ${rounded === 1 ? "day" : "days"}`;
};

export const MeetingsSection: React.FC<{ summary: EmployeeSummary }> = ({ summary }) => {
	const meetingsCount = summary.signal_counts.meetings;
	const stats = summary.meetings_stats;
	const insights = summary.meetings_insights;

	return (
		<div className="mt-1 flex flex-col gap-2">
			<div className="flex gap-2" data-testid="meetings-counts">
				{stats !== null ? (
					<>
						<StatCard label="Meeting Activity" testId="meetings-stat-activity">
							<StatRows>
								<StatRow label="Total Meetings" value={meetingsCount} testId="meetings-count-total" />
								<StatRow
									label="1:1s with Manager"
									value={stats.one_on_ones_with_manager}
									testId="meetings-stat-one-on-ones"
								/>
							</StatRows>
						</StatCard>
						<StatCard label="Action Items" testId="meetings-stat-action-items">
							<StatRows>
								<StatRow
									label="Complete"
									value={stats.action_items_complete}
									testId="meetings-stat-action-items-complete"
								/>
								<StatRow
									label="Incomplete"
									value={stats.action_items_incomplete}
									testId="meetings-stat-action-items-incomplete"
								/>
							</StatRows>
						</StatCard>
						<StatCard
							label="Avg time to complete"
							value={fmtDays(stats.avg_action_item_completion_days)}
							testId="meetings-stat-avg-completion"
						/>
						{stats.participation_rate !== null ? (
							<StatCard
								label="Participation Rate"
								value={`${Math.round(stats.participation_rate * 100)}%`}
								testId="meetings-stat-participation"
							/>
						) : null}
					</>
				) : (
					<StatCard label="Total Meetings" value={meetingsCount} testId="meetings-count-total" />
				)}
			</div>

			{insights !== null ? (
				<div className="flex flex-col gap-3" data-testid="meetings-insights">
					<BulletListSection title="Patterns" items={insights.patterns} testId="meetings-patterns" />
				</div>
			) : null}
		</div>
	);
};
